import { useRootStore } from '../stores/RootStore';

export const useEmployees = () => {
  const { employeeStore } = useRootStore();
  return employeeStore;
};
